import { Suspense } from 'react'
import Loader from '@/components/loader'

const Loadable =
  <Props extends object>(Component: React.ComponentType<Props>) =>
  (props: Props) =>
    (
      <Suspense fallback={<Loader />}>
        <Component {...props} />
      </Suspense>
    )

export default Loadable
